export enum BudgetEnum {
    LOW = "low", 
   MEDIUM = "medium", 
    HIGH = "high"
}